
import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from ".";

const axiosInstanceLogin = axios.create({
    baseURL: process.env.REACT_APP_TAURIAN_API_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }
  });

export const login = (credentials) =>
  axiosInstanceLogin.post(`/v1/auth/login`,credentials);

  axiosInstanceLogin.interceptors.response.use(
    response => {
        // Handle a successful response
        //toast.success("Login successful!");
        return response;
    },
    error => {
        const response = error.response
        // Membership problems are explained inline on the login page, so do
        // not also fire a contradictory "Invalid Credentials" toast.
        const handledInline = [
            'SUBSCRIPTION_EXPIRED',
            'SUBSCRIPTION_PAYMENT_PENDING',
        ];
        if (response && response.status === 401) {
            if (!handledInline.includes(response.data?.code)) {
                toast.error(`Invalid Credentials`);
            }
        }else{
            toast.error(`Request failed: ${error.message}`);
            
        }  
        return Promise.reject(error);  
    }
);

export const logout = () =>
    axiosInstance.post('/v1/auth/logout')
